var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select",class:{ selected: _vm.value },on:{"click":function($event){return _vm.toggler()}}},[_c('span',{staticClass:"title__small"},[_vm._t("title")],2),_c('i',{staticClass:"material-symbols-outlined",class:{open: _vm.state}},[_vm._v("arrow_drop_down")])])
}
var staticRenderFns = []

export { render, staticRenderFns }